import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './pawn.json';import texture from './pawn.png';export default new Aseprite(texture, data);